var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-password-reset d-flex align-items-center justify-content-center"},[_c('AwlModalCard',{attrs:{"title":"Reset Password"}},[_c('PasswordResetForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }